import React, { Component } from 'react';
import styled from '@emotion/styled';
import "iframe-resizer/js/iframeResizer.contentWindow.min";

// Assets
import PageData from './page-data.js';
import PageDataSpanish from './page-data-spanish.js';

// Components
import TPRSHeader from './Header';
import TPRSFooter from './Footer';
import TPRSBody from './Body';
import TPRSBodyInner from './BodyInner';
import TPRSContact from './Contact';

const WidgetContainer = styled.section`
  background-color: #CECECE;
  color: #FFFFFF;
  display: inline-block;
  font-family: 'OCRoboto', 'akzidenz-grotesk', sans-serif;
  font-size: 18px;
  left: 50%;
  margin: 0px;
  max-width: 800px;
  overflow: hidden;
  position: relative;
  transform: translateX(-50%);
  width: 100%;

  @media (max-width: 600px) {
    font-size: 16px;
  }

  @media (max-width: 480px) {
    font-size: 14px;
  }
`;

const SelectLaunguage = styled.div`
  width: 100%;
  max-width: 800px;
  margin: auto;
  display: flex;
  justify-content: center;
  border-top: 1px solid #959595;
  border-bottom: 1px solid #959595;
  background: #E6E6E6;

  > select {
    padding: 4px 16px 4px 4px;
    margin: 4px;
  }

  > label {
    padding: 4px;
    margin: 4px;
  }
`;

export default class Page extends Component {
  constructor(props) {
    super(props);
    const currentUrl = window.location.href;
    const languageRegex = /^https?:\/\/[^/]+\/([^/]+)\//;
    const tprsLanguage = currentUrl.match(languageRegex)[1];

    this.state = {
      page: 'start',
      visibility: 'hidden',
      tprsLanguage: tprsLanguage,
    }
  }

  componentDidMount() {
    const currentUrl = window.location.href;
    const languageRegex = /^https?:\/\/[^/]+\/([^/]+)\//;
    const tprsLanguage = currentUrl.match(languageRegex)[1];

    this.setState({
      visibility: 'visible',
    });
    sessionStorage.setItem( 'widget-language', tprsLanguage );
    this.handleUpdate();
    window.addEventListener('storage', this.handleUpdate);
  }

  componentWillUnmount() {
    window.removeEventListener('storage', this.handleUpdate);
  }

  handleUpdate = () => {
    const tprsLanguage = sessionStorage.getItem('widget-language');
    this.setState({ tprsLanguage: tprsLanguage });
  };

  loadPageData(page) {
    this.setState({ page: page });
  }

  includes(value) {
    for (var index = 0; i < this.length; i++) {
      if ( this[index] === value || ( this[index] !== this[index] && value !== value ) ) {
        return true;
      }
    }
    return false;
  }

  handleLanguageChange = (e) => {
    const selectedValue = e.target.value;
    this.setState({
      tprsLanguage: selectedValue ? selectedValue : sessionStorage.getItem('widget-language'),
    });
    sessionStorage.setItem("widget-language", selectedValue);
  };

  render() {
    var pageData = this.state.tprsLanguage === 'en-us' ? PageData[this.state.page] : PageDataSpanish[this.state.page];
    return (
      <main>
        <SelectLaunguage>
          <label htmlFor="language"><b>{this.state.tprsLanguage === 'en-us' ? 'Select Language' : 'Seleccionar idioma'}</b></label>
          <select id="language" value={this.state.tprsLanguage} onChange={(e) => this.handleLanguageChange(e)}>
            <option value="en-us">English</option>
            <option value="es-us">Spanish</option>
          </select>
        </SelectLaunguage>

        <WidgetContainer className={this.state.visibility}>
          <TPRSHeader
            clickEvent={(e) => this.loadPageData("start", e)}
            title="Total Protection Roofing System®"
          />

          {this.state.page === "end" ? (
            <TPRSContact
              backgroundImageUrl={pageData.bodyImageUrl}
              roofImageUrl={pageData.roofImageUrl}
              backEvent={(e) => this.loadPageData("start", e)}
              title={pageData.title}
            />
          ) : (
            ["sealInner", "defendInner", "breatheInner"].includes(this.state.page) ? (
              <TPRSBodyInner
                bodyImageUrl={pageData.bodyImageUrl}
                roofImageUrl={pageData.roofImageUrl}
                backEvent={(e) => this.loadPageData(pageData.backTarget, e)}
                title={pageData.title}
                paragraph={pageData.paragraph}
                photos={pageData.innerPhotos}
                ctaText={pageData.ctaText}
                clickEvent={(e) => this.loadPageData(pageData.ctaTarget, e)}
                back={this.state.tprsLanguage === 'en-us' ? 'Back' : 'Atrás'}
              />
            ) : (
              <TPRSBody
                bodyImageUrl={pageData.bodyImageUrl}
                roofImageUrl={pageData.roofImageUrl}
                iconUrl={pageData.iconUrl}
                title={pageData.title}
                paragraph={pageData.paragraph}
                ctaText={pageData.ctaText}
                clickEvent={(e) => this.loadPageData(pageData.ctaTarget, e)}
              />
            )
          )}

          <TPRSFooter
            activePage={this.state.page}
            clickEvent1={(e) => this.loadPageData("seal", e)}
            clickEvent2={(e) => this.loadPageData("defend", e)}
            clickEvent3={(e) => this.loadPageData("breathe", e)}
          />
        </WidgetContainer>
      </main>
    );
  }
}

const mapStateToProps = ({ screenSize }) => ({
  screenSize
});
